/**
 * FINAL COMBINED LOCALIZATION SOLUTION
 * This script prevents the theme's language pop-up by satisfying BOTH conditions we discovered:
 * 1. It sets the `languagePopupDismissed` localStorage item for the simple homepage script.
 * 2. It sets the `languageSwitcherPopup` cookie for the theme's main site-wide logic.
 * It uses the locale that Shopify automatically detects from the visitor's IP address.
 */
(function() {
  // --- Define the keys we need to set ---
  const THEME_COOKIE_NAME = 'languageSwitcherPopup';
  const THEME_LOCALSTORAGE_KEY = 'languagePopupDismissed';
  const COOKIE_EXPIRY_DAYS = 365;

  /**
   * A standard function to set a browser cookie.
   */
  function setCookie(name, value, days) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  /**
   * A standard function to get a browser cookie's value.
   */
  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Run this logic as soon as the page content is loaded.
  document.addEventListener('DOMContentLoaded', function() {
    // We check for the main cookie, as it's the most important one.
    const preferenceCookie = getCookie(THEME_COOKIE_NAME);

    // Check if the user is a new visitor (they do not have the main preference cookie).
    if (!preferenceCookie) {
      console.log("New visitor detected. Setting all necessary localization flags.");

      // --- Action 1: Set the simple localStorage key for the homepage ---
      localStorage.setItem(THEME_LOCALSTORAGE_KEY, 'true');
      
      // --- Action 2: Set the main cookie for the rest of the site ---
      const detectedLocale = Shopify.locale;
      if (detectedLocale) {
        setCookie(THEME_COOKIE_NAME, detectedLocale, COOKIE_EXPIRY_DAYS);
      }
    }
  });
})();